import { getUserPhoto48Url } from "../../../../auth/getUserPhoto48Url";
import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { IPublicClientApplication } from "@azure/msal-browser";
import { useClickAway } from "@uidotdev/usehooks";
import { AiOutlineLogout } from "react-icons/ai";
import { setGetBearerTokenFunction } from "../../../../api/api-helpers";

function InfoUser() {
  const [user, setUser] = useState({ photo: null, initials: "", name: "" });
  const [openModal, setOpenModal] = useState(false);
  const { accounts, instance } = useMsal();

  const getApiAccessToken = async (instance: IPublicClientApplication) => {
    const authRequest = {
      scopes: [process.env.REACT_APP_SCOPE || ""],
      account: accounts[0],
    };
    const response = await instance.acquireTokenSilent(authRequest);
    if (response.accessToken) {
      return response.accessToken;
    }
    return "";
  };

  const getUserAccessToken = async (instance: IPublicClientApplication) => {
    const authRequest = { scopes: ["User.Read"], account: accounts[0] };
    const response = await instance.acquireTokenSilent(authRequest);
    if (response.accessToken) {
      return response.accessToken;
    }
    return null;
  };

  const ref: any = useClickAway(() => {
    setOpenModal(false);
  });

  // Method to GET user info
  const getUserInfo = () => {
    const name = accounts[0].name || "-,-";
    console.log("username:%o", name);

    const firstInitial = (name?.split(",")[1] || "")
      .replace(/\s/g, "")
      .charAt(0);
    const secondInitial = (name?.split(",")[0] || "")
      .replace(/\s/g, "")
      .charAt(0);

    setGetBearerTokenFunction(() => getApiAccessToken(instance)); //used to set Authorization header for API invocations

    getUserAccessToken(instance).then((userAccessToken) => {
      if (userAccessToken) {
        setUser({
          ...user,
          name: name,
          initials: `${firstInitial}${secondInitial}`,
        });
        getUserPhoto48Url(userAccessToken, (response: any) => {
          if (response) {
            setUser((prev) => ({ ...prev, photo: response }));
          }
        });
      }
    });
  };

  useEffect(() => {
    getUserInfo();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="flex items-center justify-center">
      <div className="relative">
        <figure
          className="w-[34px] h-[34px] mr-2 rounded-full overflow-hidden bg-[#dadbe0] flex items-center justify-center cursor-pointer"
          onClick={(e) => setOpenModal(!openModal)}
        >
          {user.photo ? (
            <img src={`${user.photo}`} className="w-full" alt="thumbnail" />
          ) : (
            <h3 className="font-proximanova color text-[#ad1931] text-sm">
              {user.initials}
            </h3>
          )}
        </figure>
        {openModal && (
          <aside
            ref={ref}
            className="text-white bg-[#e81a3b] absolute w-48 bottom-[-38px] p-2 right-1 pl-6 cursor-pointer text-sm hover:bg-[#c70c2e] flex items-center gap-2"
            onClick={async () => {
              await instance.logoutRedirect({ account: accounts[0] });
              sessionStorage.clear();
            }}
          >
            <AiOutlineLogout size={13} />
            {"Sign Out"}
          </aside>
        )}
      </div>
      <h5 className="font-semibold text-sm" onClick={() => setOpenModal(false)}>
        {user.name}
      </h5>
    </div>
  );
}
export default InfoUser;
